import { Layout } from 'antd';
import type React from 'react';

import { FormattedTag } from 'src/components/formatted-tag/formatted-tag';
import { IconAuthLogo } from 'src/components/icons/icon-auth-logo/icon-auth-logo';
import { IconLink } from 'src/components/icons/icon-link/icon-link';
import { Button } from 'src/components/ui/button/button';
import { GASignInDimensionName, GASignInEvent } from 'src/constants';
import { sendGAEvent } from 'src/services/analytics/ga';

import './auth-layout.css';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <Layout className="min-h-screen flex flex-row min-w-[1280px]">
      <div className="auth-layout-wrapper w-1/2 text-gray-1 relative overflow-hidden">
        <div className="auth-layout-bg bg-cover bg-center bg-no-repeat absolute-fill" />
        <div className="auth-layout-lines bg-cover bg-center bg-no-repeat absolute-fill" />
        <div className="auth-layout-elements bg-cover bg-center bg-no-repeat absolute-fill" />

        <div className="auth-layout-shape absolute absolute-center-x top-[40%] text-center w-[527px] space-y-24">
          <FormattedTag id="personalization-boost" tagName="div" className="text-[46px]/[54px] font-bold" />

          <Button
            target="_blank"
            href="https://www.zingbrain.ai"
            className="inline-flex items-center gap-x-8 text-gray-1 bg-transparent border-gray-5 hover:border-gray-1"
            onClick={() => {
              sendGAEvent(GASignInEvent.SIGN_IN_CLICKS, {
                [GASignInDimensionName.SIGN_IN]: 'learn_more_link',
              });
            }}
          >
            <IconLink />
            <FormattedTag id="learn-more" />
          </Button>
        </div>
      </div>

      <div className="w-1/2 p-24">
        <div className="mt-78 mb-26 flex items-center justify-center gap-x-10">
          <img src="/assets/public/images/zing-logo.webp" alt="logo" width={52} height={50} />
          <IconAuthLogo />
        </div>

        <div className="mx-auto max-w-[421px]">{children}</div>
      </div>
    </Layout>
  );
};
